type ReqError = {
    message: string
    status: number
}

export enum HttpNameError {
    NOT_FOUND = 'NotFoundError',
    BAD_REQUEST = 'BadRequestError',
    UNAUTHORIZED = 'UnauthorizedError',
    INTERNAL_SERVER_ERROR = 'InternalServerError'
}

export class HttpError extends Error {
    status: number
    constructor({ message, status }: ReqError) {
        super(message)
        this.status = status
    }
}

export class NotFoundError extends HttpError {
    status: 404
    constructor(req: ReqError) {
        super(req)
        this.name = HttpNameError.NOT_FOUND
        this.status = 404
    }
}

export class BadRequestError extends HttpError {
    status: 400
    constructor(req: ReqError) {
        super(req)
        this.name = HttpNameError.BAD_REQUEST
        this.status = 400
    }
}

export class UnauthorizedError extends HttpError {
    status: 401
    constructor(req: ReqError) {
        super(req)
        this.name = HttpNameError.UNAUTHORIZED
        this.status = 401
    }
}

export class InternalServerError extends HttpError {
    status: 500
    constructor(req: ReqError) {
        super(req)
        this.name = HttpNameError.INTERNAL_SERVER_ERROR
        this.status = 500
    }
}
